import React from "react";
import Header from "../../common/header/header";
import { Link } from "react-router-dom";

const SiteMap = () => {
  return (
    <>
      <Header />
      <div class="site_company">
        <div class="container container_box">
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Market</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/` }}>Market</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Companies</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/company/overview` }}>Overview</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/result` }}>Latest Results</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/news` }}>News</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/researchreport` }}>
                  Research Reports
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/technicals` }}>Technicals</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/valuation` }}>Valuation</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/incomestatement` }}>
                  Income Statement
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/balancesheet` }}>
                  Balance Sheet
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/cashflow` }}>Cash Flow</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/ratio` }}>Ratios</Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/filings` }}>
                  Company Filings
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/company/financialreports` }}>
                  Financial Reports
                </Link>
              </li>
              <li>Recent Developments</li>
              <li>History</li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Data Bank</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/databank` }}>Data Bank</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Sector Fundamentals</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/sector/chemical` }}>Chemical</Link>
              </li>
              <li>
                <Link to={{ pathname: `/sector/energy/energysituation` }}>
                  Energy
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/sector/steel` }}>Steel</Link>
              </li>
              <li>
                <Link to={{ pathname: `/sector/cement` }}>Cement</Link>
              </li>
              <li>
                <Link to={{ pathname: `/sector/coal` }}>Coal</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Economy</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/economy/currency` }}>Currency</Link>
              </li>
              <li>
                <Link to={{ pathname: `/economy/inflation` }}>Inflation</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Publisher</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/publisher/investment` }}>
                  Portfolio Investment
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/publisher/morningbriefing` }}>
                  Morning Briefing
                </Link>
              </li>
              <li>
                <Link to={{ pathname: `/publisher/omc` }}>Oil Marketing</Link>
              </li>
              <li>
                <Link to={{ pathname: `/publisher/bop` }}>BOP</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Media</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/media/analystbriefing` }}>
                  Analyst Briefing
                </Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Features</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <Link to={{ pathname: `/features` }}>Features</Link>
              </li>
            </ul>
          </div>
          <div class="company_boxed">
            <div class="company-heading">
              <h1>Open an Account</h1>
              <hr class="site-underline" />
            </div>
            <ul>
              <li>
                <a
                  href="https://www.aof.com.pk/?NDIxMjQyNDg2Nzc0OTQ4NzMyNDQ4NDg3MTc2ODUyMjQ4NDc0ODQ5NA=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open an Account
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteMap;
